export default __webpack_public_path__ + "static/groups-ideas-corpo-1-7b145e03e8be917a75d5af16a8631ddf.jpg";